import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  noteSettingsUpdated: false,
  noteSettings: null,
  loading: false,
  error: null
};

const noteSettingsSlice = createSlice({
  name: "updateNoteSettings",
  initialState,
  reducers: {
    updateNoteSettingsRequest: (state,action) => {
      state.noteSettingsUpdated = false;
      state.loading = true;
      state.error = null;
    },
    updateNoteSettingsSuccess: (state, action) => {
      state.noteSettingsUpdated = action.payload;
      state.loading = false;
    },
    updateNoteSettingsError: (state, action) => {
       state.noteSettingsUpdated = false;
      state.error = action.payload;
      state.loading = false;
    },

    fetchNoteSettingsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNoteSettingsSuccess: (state, action) => {
      state.noteSettings = action.payload;
      state.loading = false;
    },
    fetchNoteSettingsError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    }
   
}});

export const {
  updateNoteSettingsRequest,
  updateNoteSettingsSuccess,
  updateNoteSettingsError,
  fetchNoteSettingsRequest,
  fetchNoteSettingsSuccess,
  fetchNoteSettingsError
} = noteSettingsSlice.actions;

export default noteSettingsSlice.reducer;